import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppAccess } from '@/hooks/useAppAccess';

interface AppAccessGuardProps {
  /** The app key to check access for (e.g., "crm", "products", "inbox") */
  requiredApp: string;
  children: ReactNode;
}

/**
 * Guard component that checks if the current user has access to a specific app.
 * Redirects to dashboard if access is denied.
 * Renders children normally if:
 * - Direct auth mode (no CP)
 * - User is admin
 * - appAccess not yet loaded (fail-open to prevent flash)
 * - User has the required app in their access list
 */
export function AppAccessGuard({ requiredApp, children }: AppAccessGuardProps) {
  const { hasAccess } = useAppAccess();

  if (!hasAccess(requiredApp)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
